module.exports = __webpack_public_path__ + "static/media/site.1d0e4e9f.webmanifest";